import { createSelector } from 'reselect'

import { RootState } from '../../../../reducers'
import { CommentsSliceState, initialState } from './slice'
import { editedCommentIdSelector } from '../../../comment/selectors'
import { isDockSectionOpenSelector } from '../../selectors'
import { nonObsoleteCommentsByIdSelector } from '../../../../components/Dock/Comments/selectors'
import { determineGroupForComment } from '../../../../components/Dock/Comments/utils'

const dialogsSliceSelector = (state: RootState): CommentsSliceState => {
  return state.dock?.sections?.comments ?? initialState
}

export function scrollTopPxSelector(state: RootState): number {
  return dialogsSliceSelector(state).scrollTopPx
}

export function stepIdFromCommentsDockSelector(state: RootState): string | undefined {
  return dialogsSliceSelector(state).stepId
}

export function intentIdFromCommentsDockSelector(state: RootState): string | undefined {
  return dialogsSliceSelector(state).intentId
}

export const currentlyCommentedStepSelector = createSelector(
  editedCommentIdSelector,
  stepIdFromCommentsDockSelector,
  isDockSectionOpenSelector('COMMENTS'),
  nonObsoleteCommentsByIdSelector,
  (editedCommentId, dockStepId, isCommentsDockOpen, comments) => {
    if (!isCommentsDockOpen) {
      return null
    }

    if (dockStepId) {
      return dockStepId
    }

    if (!editedCommentId) {
      return null
    }

    const editedCommentGroup = determineGroupForComment(comments, editedCommentId)

    if (editedCommentGroup.type !== 'step') {
      return null
    }

    return editedCommentGroup.id
  }
)
